import {i18n} from '@/plugins/i18n';
import {walletStatusStr, walletStatusVariant} from "@/constants/walletStatus";

export default [
    {
        field: 'id',
        title: i18n.t('label.identifier'),
        sortable: true,
        width: 50,
        type: 'number',
        selector: false,
        textAlign: 'center',
    },
    {
        field: 'wallet_title',
        title: i18n.t('wallets.label.wallet_title'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'amount',
        title: i18n.t('label.balance_rial'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'user',
        title: i18n.t('label.user'),
        sortable: false,
        template: row => {
            return `<a href="/users/${row.user.id}/details" target="_blank">${row.user.name}</a>`;
        },
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('label.created_at'),
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'status',
        title: i18n.t('label.status'),
        sortable: true,
        template: row => {
            return `<span class="badge badge-${walletStatusVariant(row.status)}">${walletStatusStr.get(row.status)}</span>`;
        },
        textAlign: 'center',
    },
]
